export default {
  title: 'Datos adicionales asociados a la factura',
  name: 'Nombre',
  value: 'Valor'
}
